import { X, Minus, Plus } from "lucide-react";

export function CartLine({ item: i, update, remove }) {
  return (
    <li data-testid={`cart-line-${i.variant_id}`} className="py-4 flex gap-4">
      <div className="w-20 h-24 border border-white/10 shrink-0 overflow-hidden bg-[#050508]">
        {i.image ? <img src={i.image} alt="" className="w-full h-full object-cover" /> : null}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <div className="font-display uppercase truncate">{i.name}</div>
            <div className="font-mono text-[10px] tracking-[0.2em] text-white/50 uppercase">{i.strength} · {i.unit_label || "10-vial pack"}</div>
          </div>
          <button onClick={() => remove(i.product_id, i.variant_id)} data-testid={`cart-remove-${i.variant_id}`} aria-label="Remove item" className="-mr-2 -mt-2 min-w-[44px] min-h-[44px] grid place-items-center text-white/40 hover:text-white"><X size={14} /></button>
        </div>
        <div className="mt-3 flex items-center justify-between">
          <div className="inline-flex items-center border border-white/15">
            <button aria-label="Decrease quantity" className="w-10 h-10 sm:w-8 sm:h-8 grid place-items-center text-white/70 hover:text-white" onClick={() => update(i.product_id, i.variant_id, i.quantity - 1)} data-testid={`cart-dec-${i.variant_id}`}><Minus size={12} /></button>
            <div className="w-8 text-center font-mono text-xs">{i.quantity}</div>
            <button aria-label="Increase quantity" className="w-10 h-10 sm:w-8 sm:h-8 grid place-items-center text-white/70 hover:text-white" onClick={() => update(i.product_id, i.variant_id, i.quantity + 1)} data-testid={`cart-inc-${i.variant_id}`}><Plus size={12} /></button>
          </div>
          <div className="font-display">A${(i.unit_price * i.quantity).toFixed(2)}</div>
        </div>
      </div>
    </li>
  );
}
